/** @module  */
import mapi1 from './lib/mapi.js'
import jquery from 'jquery'
import axios from 'axios';
import * as Vue from 'vue';
import * as i18n from './lib/i18n.js';
import I18NextVue from 'i18next-vue';
import i18nextBrowserLanguagedetector from 'i18next-browser-languagedetector';
import xGclid from './lib/gclid.js';
import cmp from './lib/cmp/index.vue';
import { Transition } from 'vue';
import * as version from './version.json';
import Sentry from './lib/sentry.js';

Sentry.setUser({ deviceid: mapi1.getWDeviceId() });

var tT;
if (globalThis == undefined) {
  tT = window;
} else {
  tT = globalThis;
}

tT.mapiVersion = version['version'];
tT.mapi = mapi1;
tT.jQuery = jquery;
tT.$ = jquery;
tT.axios = axios;
tT.Vue = Vue;
tT.i18n = i18n;
tT.I18NextVue = I18NextVue;
tT.i18nextBrowserLanguagedetector = i18nextBrowserLanguagedetector;
tT.xGclid = xGclid;

// axios handle error

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  Sentry.withScope(scope => {
    scope.setExtra("http.url", error.config.url);
    scope.setExtra("http.method", error.config.method);
    scope.setExtra("http.timeout", error.config.timeout);
    Sentry.captureException(error);
  });
  return Promise.reject(error);
});


if (typeof urlParams != 'object') {
  var urlParams = {};
  try {
    (function () {
      var e,
        a = /\+/g,  // Regex for replacing addition symbol with a space
        r = /([^&=]+)=?([^&]*)/g,
        d = function (s) { return decodeURIComponent(s.replace(a, " ")); },
        q = window.location.search.substring(1);
      while (e = r.exec(q)) {
        urlParams[d(e[1])] = d(e[2]);
      }
    })();
  } catch (err) {
    // nothing
  }
  tT.urlParams = urlParams;

}

window.dataLayer = window.dataLayer || [];
window.gtag = function () {
  dataLayer.push(arguments);
}
console.log("consent init");
gtag('consent', 'default', mapi.cmp());

console.log("mapi initialized, version: " + version['version']);

jquery(async () => {

  let v = document.createElement('div');
  let app = Vue.createApp(cmp)
  let ii = await i18n.getI18n({
    key: "cookie",
    onchange: function (lang) {

    },
    oninit: function (lang) {
      console.log("cookie i18n init");
    }
  });
  app.use(ii.getI18nVue(), { i18next: ii.getI18n() });
  app.component('Transition', Transition)
  let app2 = app.mount(v);
  document.body.appendChild(v);
  tT.cmp = () => {
    return app2;
  }

  var cookiekey = "xl_isinit";
  let s = localStorage.getItem(cookiekey);
  if (s != "1") {
    localStorage.setItem(cookiekey, "1");
    // init
    mapi.queryV2({
      method: "get",
      path: "login/init"
    })
  }
})

loadCSSInSameDirectory();

function loadCSSInSameDirectory() {

  // 获取当前执行脚本的路径
  try {
    var scriptPath = document.currentScript.src;
  } catch (e) {
    return;
  }

  // 截取路径中的目录部分
  var directoryPath = scriptPath.substring(0, scriptPath.lastIndexOf("/") + 1);

  // 拼接得到 CSS 文件的路径
  var cssPath = directoryPath + "style.css";

  // 创建 link 元素并添加到文档头部
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = cssPath;
  document.head.appendChild(link);
}

export default {};